import * as Yup from 'yup';

export default Yup.object({
  password: Yup.string()
    .required('Please enter a password'),
  passwordConfirmation: Yup.string()
    .required('Please confirm password')
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
});
